import _toConsumableArray from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["buttons"],
    _excluded2 = ["slideshow", "toolbar"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { SlideshowButton } from "./SlideshowButton.js";
import { PLUGIN_SLIDESHOW } from "../../core/index.js";
export var defaultSlideshowProps = {
  autoplay: false,
  delay: 3000
};
export var Slideshow = function Slideshow(_ref) {
  var augment = _ref.augment;
  augment(function (_ref2) {
    var originalSlideshow = _ref2.slideshow,
        _ref2$toolbar = _ref2.toolbar,
        buttons = _ref2$toolbar.buttons,
        restToolbar = _objectWithoutProperties(_ref2$toolbar, _excluded),
        restProps = _objectWithoutProperties(_ref2, _excluded2);

    return _objectSpread({
      toolbar: _objectSpread({
        buttons: [React.createElement(SlideshowButton, {
          key: PLUGIN_SLIDESHOW
        })].concat(_toConsumableArray(buttons))
      }, restToolbar),
      slideshow: _objectSpread(_objectSpread({}, defaultSlideshowProps), originalSlideshow)
    }, restProps);
  });
};